import userService from "@/api/services/userService";
import { useUserStore } from "@/store/user";
import { MiddlewareInterface } from "@/interfaces/Middleware.ts";

export default async ({ to, redirect, pinia }: MiddlewareInterface) => {
  if (to.path !== "/unsubscribe_mails") {
    return true;
  }

  if (!useUserStore(pinia).isLoggedIn) {
    redirect("/#log_in");
    return;
  }

  await userService.unsubscribeCameraMails();

  redirect("/user-profile/settings");
};
